module.exports = __webpack_public_path__ + "static/empty-states-illustrations-dont-223c4580dc8a8845d21536662fabb2be.png";